import {gql} from "@apollo/client";
import {SiteType} from "graphql/types/SiteType";


export const GET_ALL_WAREHOUSES = gql`
  query GetWarehouses {
    warehouses: getWarehouseListForHeadquarters {
      id
      name
      siteType
      parentSiteId
    }
  }
`; 

export interface WarehousesResponse {
    warehouses: {
        id: string;
        name: string;
        siteType: SiteType;
        parentSiteId: string;
    }[];
}